export const taskTypes = [
  "shooting",
  "cutting & sound",
  "subtitling",
  "highlight 1",
  "highlight",
  "highlight 2",
  "highlight 3",
  "scaling",
  "finishing",
  "finishing 1",
  "finishing 2",
  "finishing 3",
  "rendering",
];

export const tasks = [
  {
    id: 1,
    show: "Umu Ada",
    ep: "7",
    type: "Cutting",
    duration: "57mins",
    users: ["kelechi"],
    status: "ongoing",
    date: "15th July, 2024",
  },
  {
    id: 2,
    show: "Gbam",
    ep: "Celebrity Barrister",
    type: "Subtitling",
    duration: "1hr 2mins",
    users: ["lawrencejr", "chioma"],
    status: "completed",
    date: "15th July, 2024",
  },
  {
    id: 3,
    show: "Gbam",
    ep: "Celebrity Barrister",
    type: "Cutting",
    duration: "1hr 2mins",
    users: ["asher"],
    status: "completed",
    date: "16th July, 2024",
  },
  {
    id: 4,
    show: "Okwu Na Uka",
    ep: "3",
    type: "Shooting",
    duration: "1hr 37mins",
    users: ["vivian"],
    status: "ongoing",
    date: "16th July, 2024",
  },
  {
    id: 5,
    show: "Obiagelli Studios",
    ep: "Ike Mazelli",
    type: "Finishing",
    duration: "1hr 5mins",
    users: ["effa"],
    status: "undone",
    date: "16th July, 2024",
  },
  {
    id: 5,
    show: "Obiagelli Studios",
    ep: "Ike Mazelli",
    type: "Finishing",
    duration: "1hr 5mins",
    users: ["dave", "lawrencejr"],
    status: "ongoing",
    date: "16th July, 2024",
  },
  {
    id: 5,
    show: "Obiagelli Studios",
    ep: "Ike Mazelli",
    type: "Finishing",
    duration: "1hr 5mins",
    users: ["dave"],
    status: "undone",
    date: "16th July, 2024",
  },
  {
    id: 5,
    show: "Obiagelli Studios",
    ep: "Ike Mazelli",
    type: "Finishing",
    duration: "1hr 5mins",
    users: ["stanely"],
    status: "completed",
    date: "16th July, 2024",
  },
];
